<glitch-hero mainTitle="Oops, I couldn't find that page!"
  subtitle="It seems I haven't gotten around to making that page yet. Try going back to the home page.">
</glitch-hero>
<p>
  Go to <a routerLink="/">home</a>
</p>
